import { BrandDiamond } from "../BrandMark";

export default function LandingFooter() {
  return (
    <footer className="flex items-center justify-between gap-4 border-t pt-6 text-muted-foreground">
      <div className="flex items-center gap-2">
        <BrandDiamond />
        <span
          className="text-[15px] font-semibold text-ink2"
          style={{ fontFamily: "var(--font-serif)" }}
        >
          Eventera
        </span>
      </div>
      <span className="font-mono text-[11px] tabular-nums">
        © {new Date().getFullYear()}
      </span>
    </footer>
  );
}
